import {cookieStore} from 'libs/storage/storage';

import {LOCATION_CHANGED} from 'constants/actions';
import {getUrlParameter} from 'libs/url';

import {takeEvery, call} from 'redux-saga/effects';
import {AFF_ID} from 'constants/store';
import {createEventChannel} from '../../libs/eventChannel/eventChannel';

/**
 * Update affiliate id in LocalStorage when changing location
 * checks GET param affid
 */
export function* onLocationChange() {
    const affId = yield call(getUrlParameter, 'affid');

    if (affId) {
        yield call([cookieStore, 'set'], AFF_ID, affId);
    }
}

/**
 * Begin of saga
 */
export default function* affiliateSaga() {
    const nativeRedirect = yield call(createEventChannel, 'postMessage:redirect');

    yield takeEvery(LOCATION_CHANGED, onLocationChange);
    yield takeEvery(nativeRedirect, onLocationChange);
}
